/* ============================================================
   ELITE SUPPLEMENTS — STORE LOCATOR
   Store cards are server-rendered in store-locator.liquid (real <a href>
   per store, crawlable without JS). This script only filters/reorders that
   existing DOM — it must never rebuild it via innerHTML. window.ES_STORES
   (injected from the same metaobjects, same sort order) supplies the data
   needed for search/geolocate/distance-sort/map markers.
   ============================================================ */
(function () {
  'use strict';

  var GMAPS_KEY = 'AIzaSyDAbHXBou1xv2JlR-nvOjxSSgb5TN7F9JI';
  var STORES = (window.ES_STORES || []).slice();

  var results     = document.getElementById('loc-results');
  var emptyEl      = document.getElementById('loc-empty');
  var countEl     = document.getElementById('loc-count');
  var mapEl       = document.getElementById('loc-map-canvas');
  var tabs        = document.querySelectorAll('.loc-tab');
  var searchInput = document.getElementById('loc-search-input');
  if (!results) return;

  // Pair each store with its pre-existing server-rendered card. Both this
  // array and the Liquid loop that built the cards iterate the same
  // `stores | sort: 'name'` list, so index order lines up 1:1.
  var cardEls = Array.prototype.slice.call(results.querySelectorAll('.store-card'));
  STORES.forEach(function (s, i) {
    s._cardEl = cardEls[i] || null;
    if (!s._cardEl) return;
    s._cardEl.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      if (isMobile()) setView('map');
      focusStore(s);
    });
  });

  var splitEl = document.querySelector('.loc-split');
  var vtabs   = document.querySelectorAll('.loc-vtab');
  function isMobile() { return window.matchMedia('(max-width: 920px)').matches; }
  function scrollToMap() {
    if (!splitEl) return;
    // anchor to the (non-sticky) split, minus the sticky filter + toggle bars
    var filter = document.querySelector('.loc-filter');
    var toggle = document.querySelector('.loc-viewtoggle');
    var off = (filter ? filter.offsetHeight : 0);
    if (toggle && getComputedStyle(toggle).display !== 'none') off += toggle.offsetHeight;
    var y = window.scrollY + splitEl.getBoundingClientRect().top - off;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  function setView(v) {
    if (!splitEl) return;
    splitEl.setAttribute('data-view', v);
    vtabs.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === v); });
    if (v === 'map') {
      if (mapsReady) google.maps.event.trigger(map, 'resize');
      if (isMobile()) scrollToMap();
    }
  }

  var AU = ['ACT', 'NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'NT'];
  var state = { filter: 'all', query: '', pos: null, origin: '' };
  var map, info, userMarker, searchMarker, routeLine, directionsService, directionsRenderer, mapsReady = false;

  function svg(id) { return '<svg><use href="' + id + '"></use></svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function telHref(p) { return 'tel:' + String(p).replace(/[^0-9+]/g, ''); }
  function distKm(a, b) {
    var R = 6371, toRad = function (d) { return d * Math.PI / 180; };
    var dLat = toRad(b.lat - a.lat), dLng = toRad(b.lng - a.lng);
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }
  function fmtDist(km) { return km < 10 ? km.toFixed(1) + ' km' : Math.round(km) + ' km'; }
  function hasGeo(s) { return s.lat && s.lng; }

  function matches(s) {
    if (state.filter === 'INT') { if (AU.indexOf(s.state) !== -1) return false; }
    else if (state.filter !== 'all' && s.state !== state.filter) return false;
    var q = state.query.trim().toLowerCase();
    if (!q) return true;
    return ((s.name || '') + ' ' + (s.state || '') + ' ' + (s.address || '')).toLowerCase().indexOf(q) !== -1;
  }

  /* ---------- focus a store (card + map) ---------- */
  function focusStore(s) {
    document.querySelectorAll('.store-card.is-active').forEach(function (c) { c.classList.remove('is-active'); });
    if (s._cardEl) s._cardEl.classList.add('is-active');
    if (mapsReady && s._marker) {
      // defer a frame: if the map was just revealed (list→map), let it size up first
      requestAnimationFrame(function () {
        map.panTo(s._marker.getPosition());
        map.setZoom(14);
        openInfo(s);
      });
    }
  }
  function openInfo(s) {
    if (!info) return;
    info.setContent(
      '<div style="font-family:Arial,sans-serif;max-width:230px;line-height:1.4">' +
        '<strong style="font-size:15px;font-weight:700;color:#7256e3">' + esc(s.name) + '</strong><br>' +
        '<span style="color:#666;font-size:13px">' + esc(s.address || '') + '</span>' +
        (s.url ? '<br><a href="' + s.url + '" style="color:#7256e3;font-weight:600;font-size:13px;text-decoration:none">View store &rarr;</a>' : '') +
      '</div>');
    info.open(map, s._marker);
  }

  /* ---------- list: update badges/links on existing cards, never rebuild ---------- */
  function updateCardBadge(s) {
    if (!s._cardEl) return;
    var distEl = s._cardEl.querySelector('.store-card__dist');
    var ccEl = s._cardEl.querySelector('.store-card__cc');
    if (s._d != null) {
      if (distEl) { distEl.hidden = false; distEl.textContent = fmtDist(s._d); }
      if (ccEl) ccEl.hidden = true;
    } else {
      if (distEl) distEl.hidden = true;
      if (ccEl) ccEl.hidden = false;
    }
  }
  function updateCardDirections(s) {
    if (!s._cardEl) return;
    var a = s._cardEl.querySelector('.store-card__cta .btn--primary');
    if (!a) return;
    var dest = encodeURIComponent(s.address || s.name);
    a.href = state.origin
      ? 'https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(state.origin) + '&destination=' + dest
      : 'https://maps.google.com/?q=' + dest;
  }

  function render() {
    var list = STORES.filter(matches);
    if (state.pos) {
      list.forEach(function (s) { s._d = hasGeo(s) ? distKm(state.pos, s) : null; });
      list.sort(function (a, b) { return (a._d == null ? Infinity : a._d) - (b._d == null ? Infinity : b._d); });
    } else { list.forEach(function (s) { s._d = null; }); }

    STORES.forEach(function (s) { if (s._cardEl) s._cardEl.hidden = true; });

    if (!list.length) {
      if (emptyEl) emptyEl.hidden = false;
    } else {
      if (emptyEl) emptyEl.hidden = true;
      list.forEach(function (s) {
        if (!s._cardEl) return;
        s._cardEl.hidden = false;
        updateCardBadge(s);
        updateCardDirections(s);
        results.appendChild(s._cardEl); // moves the existing node — reorders, doesn't recreate
      });
    }
    if (emptyEl) results.appendChild(emptyEl); // keep it last, harmless while hidden

    if (countEl) countEl.innerHTML = '<b>' + list.length + '</b> ' + (list.length === 1 ? 'store' : 'stores');
    syncMarkers();
  }

  /* ---------- map ---------- */
  function loadMaps(cb) {
    if (window.google && window.google.maps) { cb(); return; }
    if (window.__esMapsLoading) { var t = setInterval(function () { if (window.google && window.google.maps) { clearInterval(t); cb(); } }, 120); return; }
    window.__esMapsLoading = true;
    window.__esMapsReady = function () { cb(); };
    var sc = document.createElement('script');
    sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + GMAPS_KEY + '&libraries=places&callback=__esMapsReady&loading=async';
    sc.async = true; document.head.appendChild(sc);
  }

  function initMap() {
    if (!mapEl) return;
    map = new google.maps.Map(mapEl, {
      center: { lat: -25.3, lng: 133.8 }, zoom: 4,
      mapTypeControl: false, streetViewControl: false, fullscreenControl: true,
      gestureHandling: 'greedy'
    });
    info = new google.maps.InfoWindow();
    directionsService = new google.maps.DirectionsService();
    directionsRenderer = new google.maps.DirectionsRenderer({
      map: map, suppressMarkers: true, preserveViewport: false,
      polylineOptions: { strokeColor: '#7256e3', strokeOpacity: 0.9, strokeWeight: 5 }
    });
    // Branded map pin image (120x152 SVG on the Shopify CDN); tip is at bottom-centre
    var ES_PIN = {
      url: 'https://elitesupps.com.au/cdn/shop/files/map-pin.svg?v=1780910073',
      scaledSize: new google.maps.Size(36, 46),
      anchor: new google.maps.Point(18, 46)
    };
    STORES.forEach(function (s) {
      if (!hasGeo(s)) { s._marker = null; return; }
      var m = new google.maps.Marker({ position: { lat: +s.lat, lng: +s.lng }, title: s.name, icon: ES_PIN });
      m.addListener('click', function () {
        focusStore(s);
        if (s._cardEl) s._cardEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      s._marker = m;
    });
    mapsReady = true;
    syncMarkers();
    initAutocomplete();
  }

  function clearRoute() {
    if (directionsRenderer) directionsRenderer.setDirections({ routes: [] });
    if (routeLine) { routeLine.setMap(null); routeLine = null; }
  }
  function drawStraight(a, b) {
    routeLine = new google.maps.Polyline({ path: [a, b], map: map, geodesic: true, strokeColor: '#7256e3', strokeOpacity: 0.85, strokeWeight: 3 });
  }
  // real driving route; falls back to a straight line if Directions fails
  function showRoute(origin, dest) {
    clearRoute();
    if (directionsService && directionsRenderer) {
      directionsService.route(
        { origin: origin, destination: dest, travelMode: google.maps.TravelMode.DRIVING },
        function (res, status) {
          if (status === 'OK') directionsRenderer.setDirections(res);
          else drawStraight(origin, dest);
        });
    } else { drawStraight(origin, dest); }
  }
  function clearSearchOverlay() {
    if (searchMarker) { searchMarker.setMap(null); searchMarker = null; }
    clearRoute();
    state.origin = '';
  }

  // Places Autocomplete on the search box → pick a street/suburb → nearest store + route
  function initAutocomplete() {
    if (!searchInput || !(window.google.maps.places && google.maps.places.Autocomplete)) return;
    var ac = new google.maps.places.Autocomplete(searchInput, {
      fields: ['geometry', 'name', 'formatted_address'],
      componentRestrictions: { country: 'au' },
      types: ['geocode']
    });
    ac.addListener('place_changed', function () {
      var place = ac.getPlace();
      if (!place || !place.geometry || !place.geometry.location) return;
      var loc = place.geometry.location;
      clearSearchOverlay();
      state.pos = { lat: loc.lat(), lng: loc.lng() };
      state.origin = place.formatted_address || place.name || '';
      state.query = '';
      state.filter = 'all';
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-state') === 'all'); });
      if (isMobile()) setView('map');
      render();

      searchMarker = new google.maps.Marker({
        position: state.pos, map: map, title: place.name || 'Searched location', zIndex: 999,
        icon: { path: google.maps.SymbolPath.CIRCLE, scale: 8, fillColor: '#111', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 }
      });

      var near = STORES.filter(hasGeo)
        .map(function (s) { return { s: s, d: distKm(state.pos, s) }; })
        .sort(function (a, b) { return a.d - b.d; })[0];
      var b = new google.maps.LatLngBounds(); b.extend(state.pos);
      if (near) {
        b.extend(near.s._marker.getPosition());
        document.querySelectorAll('.store-card.is-active').forEach(function (c) { c.classList.remove('is-active'); });
        if (near.s._cardEl) near.s._cardEl.classList.add('is-active');
        openInfo(near.s);
        showRoute(state.pos, near.s._marker.getPosition());
      }
      map.fitBounds(b);
      var bar = document.querySelector('.loc-filter');
      if (bar) window.scrollTo({ top: bar.offsetTop - 1, behavior: 'smooth' });
    });
  }

  // show only markers for the currently-filtered stores, fit the view to them
  function syncMarkers() {
    if (!mapsReady) return;
    var b = new google.maps.LatLngBounds(), n = 0;
    STORES.forEach(function (s) {
      if (!s._marker) return;
      var vis = matches(s);
      s._marker.setMap(vis ? map : null);
      if (vis) { b.extend(s._marker.getPosition()); n++; }
    });
    if (state.pos) b.extend(state.pos);
    if (n) { map.fitBounds(b); if (n === 1) map.setZoom(14); }
  }

  /* ---------- controls ---------- */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      state.filter = tab.getAttribute('data-state');
      clearSearchOverlay();
      render();
    });
  });

  vtabs.forEach(function (b) {
    b.addEventListener('click', function () { setView(b.getAttribute('data-view')); });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () { state.query = searchInput.value; clearSearchOverlay(); render(); });
    var form = document.getElementById('loc-search-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      render();
      var bar = document.querySelector('.loc-filter');
      if (bar) window.scrollTo({ top: bar.offsetTop - 1, behavior: 'smooth' });
    });
  }

  var geoBtn = document.getElementById('loc-geo');
  if (geoBtn) geoBtn.addEventListener('click', function () {
    if (!navigator.geolocation) return;
    var label = geoBtn.innerHTML;
    geoBtn.textContent = 'Locating…';
    navigator.geolocation.getCurrentPosition(function (p) {
      state.pos = { lat: p.coords.latitude, lng: p.coords.longitude };
      render();
      if (mapsReady) {
        if (userMarker) userMarker.setMap(null);
        userMarker = new google.maps.Marker({
          position: state.pos, map: map, title: 'You are here',
          icon: { path: google.maps.SymbolPath.CIRCLE, scale: 7, fillColor: '#1a73e8', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 }
        });
        map.setCenter(state.pos); map.setZoom(10);
      }
      geoBtn.innerHTML = svg('#i-nav') + 'Nearest first';
      var bar = document.querySelector('.loc-filter');
      if (bar) window.scrollTo({ top: bar.offsetTop - 1, behavior: 'smooth' });
    }, function () { geoBtn.innerHTML = label; }, { timeout: 8000 });
  });

  // store count in each tab (skip "All")
  function setTabCounts() {
    tabs.forEach(function (tab) {
      var st = tab.getAttribute('data-state');
      if (st === 'all') return;
      var n = st === 'INT'
        ? STORES.filter(function (s) { return AU.indexOf(s.state) === -1; }).length
        : STORES.filter(function (s) { return s.state === st; }).length;
      var base = tab.getAttribute('data-label') || tab.textContent.trim();
      tab.setAttribute('data-label', base);
      tab.innerHTML = base + ' <span class="loc-tab__n">(' + n + ')</span>';
    });
  }

  setTabCounts();
  render();
  loadMaps(initMap);
})();
